// @ts-nocheck

import eventBus from "@legacy/modules/event-bus.module.ts";
import { showPopup } from "@legacy/modules/popup.module.ts";
import { commonState } from "@legacy/modules/common-state.module.ts";

// Изменение стилей карточки после измениния количества товара
eventBus.subscribe("cart-changed", ({ variantId, quantity }) => {
    const addToCartButton = document.querySelectorAll(
        `[data-catalog-product-card] [data-add-to-cart-btn][data-variant-id="${variantId}"]`,
    );
    const counter = document.querySelectorAll(
        `[data-catalog-product-card] [data-counter][data-variant-id="${variantId}"]`,
    );
    if (quantity > 0) {
        if (addToCartButton) {
            addToCartButton.forEach((e) => e.classList.add("display-none"));
        }
        if (counter) {
            counter.forEach((e) => e.classList.remove("display-none"));
        }
    } else {
        if (addToCartButton) {
            addToCartButton.forEach((e) => e.classList.remove("display-none"));
        }
        if (counter) {
            counter.forEach((e) => e.classList.add("display-none"));
        }
    }
});

// При нажатии на кнопку Добавить, спрятать эту кнопку и показать счетчик
const productCards = document.querySelectorAll("[data-catalog-product-card]");
productCards.forEach((productCard) => {
    const addButton = productCard.querySelector("[data-add-btn]");
    const counter = productCard.querySelector("[data-counter]");

    if (addButton) {
        addButton.addEventListener("click", () => {
            addButton.classList.add("display-none");
            if (counter) {
                counter.classList.remove("display-none");
            }
        });
    }
});

// Показать уведомление, если товар добавлен в корзину
eventBus.subscribe("cart-changed", ({ quantity, quantityPrev }) => {
    if (quantity > quantityPrev) {
        showPopup(commonState.translations["Product added to cart"], 3000);
    }
});
